// action types
// 用户登录
export const SAVE_USERINFO = 'SAVE_USERINFO';
// 清楚数据
export const CLEAR_STATE = 'CLEAR_STATE'; 

